/** 静态目录首页与站内规范 URL 使用同一路由，包括直接打开 index.html。 */
export function normalizeRoutePath(pathname: string): string {
  return pathname.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
}
/** 已取消展示的页面：部署时移除旧 HTML，并验证各 URL 形式返回 404。 */
export const retiredRoutes = ['/cases', '/scenarios', '/about'];
